import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AlertService } from '../components/alert/alert.service';
import { PermisosService } from '../services/permisos.service';

/**
 * Guardia de UX (NO de seguridad): oculta secciones a quien no tiene permiso. La API vuelve a comprobar cada acción
 * con denegación por defecto, de modo que saltarse esta guardia no concede nada.
 * - permisos: basta con tener alguno (global o limitado a una asociación).
 * - soloGlobal: exige alcance global (p. ej. listados completos de personas).
 */
export function permisoGuard(permisos: string[], options?: { soloGlobal?: boolean }): CanActivateFn {
  return () => {
    const servicio = inject(PermisosService);
    const router = inject(Router);
    const alertas = inject(AlertService);
    return servicio.cargarContexto().pipe(
      map(() => {
        const permitido = options?.soloGlobal
          ? permisos.some(permiso => servicio.tieneGlobal(permiso))
          : servicio.tieneAlguno(permisos);
        if (permitido) return true;
        alertas.warning('No tienes permiso para acceder a esta sección.', 5000);
        return router.createUrlTree(['/home']);
      })
    );
  };
}
